<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      title="认购有礼"
      @click-left="goableBack()"></van-nav-bar>
    <div class="buy-view-bg">
      <div class="view-top"></div>
      <div class="subscription-list">
        <div class="table-header-bg">
          <table>
            <caption>
              获赠记录
            </caption>
            <thead>
              <tr></tr>
              <tr>
                <th>日期</th>
                <th>期限</th>
                <th>金额</th>
                <th>积分变化</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body-bg">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <!-- finished-text="没有更多了" -->
            <van-list
              class="list"
              v-model="loading"
              @load="onLoad"
              :finished="finished"
              :offset="10">
              <table>
                <tbody>
                  <tr v-for="(item, i) of dataSource" :key="i">
                    <!-- <td>{{ item.createTime.split(" ")[0] }}</td> -->
                    <td>{{ dateFormat(item.createTime, "YYYY-MM-DD") }}</td>
                    <td>{{ item.dayNumber }}天</td>
                    <td>{{ item.amount }}元</td>
                    <td>+{{ item.score }}</td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <div class="buy-rule-bg">
        <div class="title">{{ $route.params.descTitle }}</div>
        <div class="buy-rule-content" v-html="$route.params.descriptions">
          <!-- 1、投资期限10个月及以下：投资金额*0.01*会员积分成长系数；
          <br />
          <br />
          2、投资期限10个月以上：投资金额*0.015*会员积分成长系数；
          <br />
          <br />
          3、积分将在产品起息之后24小时内到账。 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import { List, PullRefresh } from "vant"
import * as MemberIntegralApi from "@/api/memberIntegral"
export default {
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      finished: false,
      refreshing: false,
      params: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    onRefresh() {
      this.params.pageNum = 1
      this.onLoad()
    },
    onLoad() {
      MemberIntegralApi.getSubscribeSendScore(this.params)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.params.pageNum === 1) {
              this.finished = false
              this.dataSource = data
            } else {
              this.dataSource = this.dataSource.concat(data)
            }
            if (data.length < this.params.pageSize) {
              this.finished = true
            } else {
              this.params.pageNum++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scope>
.buy-view-bg {
  background-image: url(../../assets/img/memberIntegral/mi_buy_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 0;
  .view-top {
    height: 170px;
  }
  .title {
    color: black;
    font-weight: 500;
    font-size: 18px;
    align-items: center;
    text-align: center;
    padding-top: 15px;
  }
  .subscription-list {
    // Firefox4.0-
    -moz-box-shadow: 2px 2px 10px rgb(212, 214, 211);
    // Safariand Google chrome10.0-
    -webkit-box-shadow: 2px 2px 10px rgb(212, 214, 211);
    // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
    box-shadow: 2px 2px 10px rgb(212, 214, 211);
    margin: 15px;
    padding-bottom: 5px;
    background-color: white;
    border-radius: 10px;
    // height: 25vh;
    .table-header-bg {
      table {
        border-collapse: collapse;
        margin: 10px;
        width: calc(100vw - 14vw);
        margin-bottom: 0px;
        caption {
          margin: 10px 0;
          color: black;
          font-size: 16px;
          font-weight: 700;
        }
        th {
          color: rgb(105, 109, 111);
          font-size: 17px;
          font-weight: 500;
          text-align: center;
          width: 25%;
        }
      }
    }
    .table-body-bg {
      overflow: auto;
      // height: 240px;
      height: 108px;
      table {
        margin: 10px;
        width: calc(100vw - 14vw);
        td {
          color: rgb(110, 113, 113);
          font-size: 14px;
          font-weight: 500;
          height: 44px;
          text-align: center;
          border-top: 1px solid rgb(234, 234, 234);
          width: 25%;
        }
      }
    }
  }
  .buy-rule-bg {
    margin: 0 15px;
    margin-top: 20px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    // Firefox4.0-
    -moz-box-shadow: 2px 2px 10px rgb(226, 226, 218);
    // Safariand Google chrome10.0-
    -webkit-box-shadow: 2px 2px 10px rgb(226, 226, 218);
    // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
    box-shadow: 2px 2px 10px rgb(226, 226, 218);
    .buy-rule-content {
      margin-left: 30px;
      margin-right: 30px;
      margin-top: 20px;
      padding-bottom: 30px;
      color: rgb(80, 80, 80);
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>